import styled from "styled-components";
import { primaryColor } from "../../config/constants";

export const SoftwareButtonsMain = styled.div`
  margin: 0 auto 20px;
  width: 100%;
  max-width: 860px;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const SoftwareButtonsDiv = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
export const SoftwareButton = styled.button`
  margin-right: 10px;
  padding-right: 10px;
  width: 100px;
  font-size: 14px;
  font-weight: ${({ active }) => active && "bold"};
  color: ${({ active }) => (active ? "#808080" : primaryColor)};
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  @media (max-width: 490px) {
    font-size: 12px;
  }
`;
export const SessionHeaderMainDiv = styled.div`
  margin: 0 auto 10px;
  width: 100%;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
    max-width: 860px;
  }
`;
export const SessionHeaderDiv = styled.div`
  width: 100%;
  max-width: 860px;
  display: flex;
`;
export const SessionTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const SessionHideDiv = styled.div`
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
